import { render, staticRenderFns } from "./ContactEditForm.vue?vue&type=template&id=de9a5e2a"
import script from "./ContactEditForm.vue?vue&type=script&lang=js"
export * from "./ContactEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports